import {gridMinmax, gridRepeat, gridTracks, GridTemplate, ValueByDevice} from 'platform/foundation';

import {DAYS_IN_WEEK} from './daysInWeek';
import {MAX_DAY_WIDTH} from './maxDayWidth';

/**
 * Day columns shared by every grid that has to line up with the days: the weekday header, the week
 * rows and the all-day header. Mobile keeps every day at a fixed width and scrolls sideways;
 * larger screens share the width.
 */
export const DAY_COLUMN_TEMPLATE: ValueByDevice<GridTemplate> = [
  gridTracks(gridRepeat(DAYS_IN_WEEK, MAX_DAY_WIDTH)),
  gridTracks(gridRepeat(DAYS_IN_WEEK, gridMinmax(MAX_DAY_WIDTH, '1fr'))),
];
